var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105.345,
    height: 105.345,
    viewBox: "0 0 105.345 105.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(616.164 -3002.963) rotate(16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(262 3054)",
    fill: "#0292d3",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.169,
    height: 77.169,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 81.169,
    height: 81.169,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(269.585 3062.09)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.328,0A1.518,1.518,0,0,0,0,1.465v58.6a1.522,1.522,0,0,0,1.465,1.465h58.6a1.522,1.522,0,0,0,1.465-1.465V1.465A1.522,1.522,0,0,0,60.069,0H1.328Zm1.6,2.93H29.3V29.3H2.93Zm29.3,0H58.6V29.3H32.233ZM15.956,9.5a1.517,1.517,0,0,0-1.3,1.488v3.663h-3.8a1.467,1.467,0,1,0,.137,2.93h3.663v3.663a1.465,1.465,0,1,0,2.93,0V17.581h3.663a1.465,1.465,0,1,0,0-2.93H17.581V10.988A1.529,1.529,0,0,0,15.956,9.5Zm26.372,1.465a1.465,1.465,0,0,0-.87,2.518l3.365,3.365-3.365,3.342a1.465,1.465,0,1,0,2.06,2.083l3.365-3.365,3.365,3.365a1.465,1.465,0,1,0,2.06-2.083l-3.365-3.342,3.365-3.365A1.465,1.465,0,0,0,51.1,10.965a1.477,1.477,0,0,0-.847.435l-3.365,3.365L43.518,11.4a1.488,1.488,0,0,0-1.19-.435ZM2.931,32.232H29.3V58.6H2.931Zm29.3,0H58.606V58.6H32.234Zm7.921,8.058a1.467,1.467,0,1,0,.137,2.93H50.547a1.465,1.465,0,1,0,0-2.93H40.154Zm-27.837,4.4a1.467,1.467,0,1,0,.137,2.93H22.711a1.465,1.465,0,1,0,0-2.93H12.317Zm27.837,2.93a1.466,1.466,0,1,0,.137,2.93H50.547a1.465,1.465,0,1,0,0-2.93H40.154Z",
    transform: "translate(0 0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalc);
export default __webpack_public_path__ + "static/media/calc.1c5b0416bbbd8f4ff032049d00b1743e.svg";
export { ForwardRef as ReactComponent };